/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BasicInformation/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function BasicInformation({
  children,
  viewPath = "/DesignSystem/PatientOverview/Content/BasicInformation"
  
}) {
let patientPersonValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'person',
})
let aggregateData = fromAggregate.basicPatientInformation(patientPersonValueData)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 color={dtColorsNeutral900}
 data="patient.person"
 aggregate="/Data/aggregate.js basicPatientInformation"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}